import { gql } from "@apollo/client";


export const TOGGLE_FAVORITE = gql`
    mutation ToggleFavorite($id: ID!) {
        toggleChatFavorite(id: $id) {
            id
            isFavorite
        }
    }
`;